<template>
  <div :style="{'direction': $vs.rtl ? 'rtl' : 'ltr'}">
    <feather-icon @click="confirmDeleteRecord" icon="Trash2Icon" svgClasses="h-5 w-5 mr-4 hover:text-primary cursor-pointer"/></div>
</template>

<script>
export default {

  methods: {
    confirmDeleteRecord () {
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: 'Cancel Subscription',
        text: 'Please confirm you want to cancel this subscription.',
        accept: this.deleteRecord,
        acceptText: 'Accept'
      })
    },
    deleteRecord () {

      this.$vs.loading()

      this.$http.delete(`subscriptions/${this.params.value}`)
        .then(response => {

          this.$vs.loading.close()

          if (response.status === 200) {
            this.params.loadProductBuffer()

            return this.$vs.notify({
              color: 'success',
              title: 'Subscription Cancelled',
              text: 'You have successfully cancelled this subscription',
              position: 'top-right'
            })
          }

          this.showError({response})
        })
        .catch(this.showError)

    }
  }
}
</script>
